module.exports = __webpack_public_path__ + "static/media/house2.40b6698b.png";